<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <Tables
          ref="tableGrid"
          :columns="[
            'Data',
            'Quantidade de Parcelas',
            'Valor Total',
            'Valor da Parcela',
            'Taxa de Juros',
            'Valor Total (com juros)',
            'Ações'
          ]"
          v-on:Load="onLoad"
          :showPaging="false"
        >
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <TableColumn :IsCustom="true" >{{ formatDate(obj.data) }}</TableColumn>
          <TableColumn :IsCustom="true" >{{ obj.quantidadeParcelas }}</TableColumn>
          <TableColumn :IsCustom="true" >{{ obj.valorTotal }}</TableColumn>
          <TableColumn :IsCustom="true" >{{ obj.valorParcela }}</TableColumn>
          <TableColumn :IsCustom="true" >{{ obj.taxaJuros }}</TableColumn>
          <TableColumn :IsCustom="true" >{{ obj.valorTotalComJuros }}</TableColumn>
          <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" />
        </tr>
        </Tables>
      </div>
    </div>
    <ModalSimulacao
      ref="ModalSimulacao"
      :card="card"
      :person="person"
      @Reload="onReload"
    />
  </div>
</template>
<script>
import CrmDetailsSimulacao from './simulacao.js'

export default CrmDetailsSimulacao
</script>
<style lang="scss">
.nav.nav-pills {
  li.nav-item {
    margin-bottom: 0.2rem;
  }
}
</style>
<style scoped>
.no-border {
  border: 0px;
}
</style>
<style>
.hover-link:hover {
  color: #04a791;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/simulacao/simulacao.vue